import React from 'react';
import { DesktopProfilesMenu } from 'containers/ProfileManager/components/DesktopProfilesMenu';
import './style.scss';
import { OpcionMenuAdmin } from '../OpcionMenuAdmin';
import { useProfiles } from 'containers/ProfileManager/hooks/useProfiles';
import { useDispatch } from 'react-redux';
import { hideMenuAvatar } from 'containers/MenuAvatar/actions/menuAvatar.actions';

export const MenuAvatarDesktop = ({ onClose }) => {
  const { profilesEnable } = useProfiles();

  const dispatch = useDispatch();

  const handleMouseLeave = e => {
    e.stopPropagation();
    dispatch(hideMenuAvatar());
  };

  return (
    <>
      <ul
        className="menu-avatar-desktop"
        onMouseLeave={e => handleMouseLeave(e)}
      >
        <div className="menu-avatar-desktop__hover-utility" />
        {profilesEnable && <DesktopProfilesMenu onClose={onClose} />}
        <OpcionMenuAdmin onClose={onClose} />
      </ul>
    </>
  );
};
